var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62 60.213a11.635 11.635 0 01-3.26-3.239 12.211 12.211 0 01-1.81-4.305 106.566 106.566 0 01-.442-41.287c.29-1.535.873-2.99 1.712-4.277 1.735-2.647 4.4-4.458 7.418-5.042a103.627 103.627 0 0140.899-.05l-.005.011c1.512.296 2.96.894 4.262 1.762a11.676 11.676 0 013.255 3.244 12.25 12.25 0 011.81 4.305 106.646 106.646 0 01.44 41.283 11.802 11.802 0 01-1.71 4.277c-1.738 2.648-4.406 4.459-7.425 5.043a103.652 103.652 0 01-40.892.045c-1.51-.3-2.953-.9-4.252-1.77z",
    fill: "#C2E9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.693 47.937a12.377 12.377 0 01-8.794-3.678 12.62 12.62 0 01-3.643-8.88V19.401l12.437-3.338 12.437 3.338v15.978c0 3.33-1.31 6.525-3.643 8.88a12.377 12.377 0 01-8.794 3.678v0z",
    stroke: "#00A1DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.28 31.332l4.627 4.673 8.141-8.218",
    stroke: "#00A1DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgShield;